import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getStudent,
  studentStatus,
} from "../../../features/slices/studentManagementReducer";
import moment from "moment";
import { Link, useLocation } from "react-router-dom";
import CommonPagination from "../../CommonPagination";
import ExportToExcel from "../../ExportToExcel";
import { getStudentLiveStream } from "../../../features/slices/studentManagement/studentLiveStream";
import TableSkeleton from "../../TableSkeleton";

const initialState = {
  currentPage: 1,
  searchQuery: "",
  fromDate: "",
  toDate: "",
  timeframe: "",
  status: "",
};
const LiveStreamDetails = () => {
  const [iState, setUpdateState] = useState(initialState);
  const { currentPage, searchQuery, fromDate, toDate, timeframe, status } =
    iState;
  const [page, setPage] = useState(1);
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { liveStream, loading } = useSelector((state) => {
    return state?.studentLiveStream;
  });

  const totalCount = liveStream?.result?.[0]?.totalCount?.[0]?.count || 0;
  const itemsPerPage = 10;
  const startIndex = (currentPage - 1) * itemsPerPage + 1;
  const endIndex = Math.min(currentPage * itemsPerPage, totalCount);

  useEffect(() => {
    dispatch(getStudentLiveStream({ userId: state?._id, page }));
  }, [page]);
  useEffect(() => {
    if (searchQuery.trim() !== "") {
      const delayDebounceFunc = setTimeout(() => {
        dispatch(
          getStudentLiveStream({
            search: searchQuery?.trim(),
            userId: state?._id,
          })
        ).then((res) => {
          if (res?.payload?.code == 200) {
            // setUpdateState((prev) => ({
            //   ...prev,
            //   searchQuery: "",
            // }));
          }
        });
      }, 1000);
      return () => clearTimeout(delayDebounceFunc);
    }
  }, [searchQuery, dispatch]);

  const handleTimeFrame = (e) => {
    const queryParams = { timeframe: e.target.value, userId: state?._id };
    dispatch(getStudentLiveStream(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
        setUpdateState((prev) => ({
          ...prev,
          timeframe: "",
        }));
      }
    });
  };

  const handleReset = () => {
    setUpdateState(initialState);
    dispatch(getStudentLiveStream({ userId: state?._id }));
  };
  const handleSearch = (e) => {
    const { name, value } = e.target;
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSubmit = () => {
    const queryParams = {
      page: 1,
      search: searchQuery?.trim(),
      status: status,
      userId: state?._id,
    };
    if (fromDate && toDate) {
      queryParams.startDate = fromDate;
      queryParams.endDate = toDate;
    } else if (timeframe) {
      queryParams.timeframe = timeframe;
    }
    dispatch(getStudentLiveStream(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
        setUpdateState((prev) => ({
          ...prev,
          searchQuery: "",
          fromDate: "",
          toDate: "",
          timeframe: "",
        }));
      }
    });
  };
  return (
    <div className="tab-pane fade active show">
      <div className="FilterArea">
        <div className="FilterLeft">
          <div className="form-group">
            <label>From Date</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              disabled={timeframe}
              name="fromDate"
              onChange={(e) => handleSearch(e)}
            />
          </div>
          <div className="form-group">
            <label>To Date</label>
            <input
              type="date"
              className="form-control"
              name="toDate"
              value={toDate}
              disabled={timeframe}
              onChange={(e) => handleSearch(e)}
            />
          </div>
          <div className="form-group">
            <label>&nbsp;</label>
            <button className="Button" onClick={handleSubmit}>
              Apply
            </button>
          </div>
          <div className="form-group">
            <label>Timeframe</label>
            <select
              className="form-control"
              name="timeframe"
              value={timeframe}
              disabled={fromDate || toDate}
              onChange={(e) => handleTimeFrame(e)}
            >
              <option value="" hidden>
                Select
              </option>
              <option value="Today">Today</option>
              <option value="Week">This Week</option>
              <option value="Month">This Month</option>
            </select>
          </div>
        </div>
      </div>
      <div className="NewFilter">
        <div className="SearchBox">
          <input
            type="search"
            className="SearchInput"
            placeholder="Search here by Id, title, or Others"
            name="searchQuery"
            value={searchQuery}
            onChange={(e) => handleSearch(e)}
          />
          <span>
            <i className="fa fa-search" />
          </span>
        </div>

        <div className="Actions">
          <button className="Button Cancel  ml-2" onClick={handleReset}>
            <i className="fa fa-refresh" />
          </button>
          <ExportToExcel
            data={liveStream?.result?.[0]?.paginationData}
            fileName="liveStream"
          />
        </div>
      </div>
      <div className="TableList">
        <table className="table-hover">
          <thead>
            <tr>
              <th>Sr. No</th>
              <th>Live Stream Id</th>
              <th>Title of Live Stream</th>
              <th>Instructor Name</th>
              <th>Category &amp; Topic</th>
              <th>Live Stream Date</th>
              <th>Ratings</th>
            </tr>
          </thead>
          <tbody>
            {!loading ? (
              liveStream?.result?.[0]?.paginationData?.length > 0 ? (
                liveStream?.result?.[0]?.paginationData?.map((res, i) => {
                  return (
                    <tr key={res?._id}>
                      <td>{i + 1 + (page - 1) * 10}</td>
                      <td>{res?.streamData?.[0]?.stream_number}</td>
                      <td>{res?.streamData?.[0]?.title}</td>
                      <td>{res?.streamData?.[0]?.teacherName}</td>
                      <td>
                        {res?.categoryData?.[0]?.categoryName} &amp;{" "}
                        {res?.topicData?.[0]?.topicName}
                      </td>
                      <td>
                        {moment(
                          res?.streamData?.[0]?.liveStreamStartDate
                        ).format("DD/MM/YYYY")}
                      </td>
                      <td>
                        <Link
                          to={"/livestream/review?type=student"}
                          className="LinkDirect"
                          state={res?._id}
                        >
                          <strong>{res?.averageRating} </strong> (
                          {res?.ratingCount})
                        </Link>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={10}>No LiveStream Data</td>
                </tr>
              )
            ) : (
              <TableSkeleton />
            )}
          </tbody>
        </table>
      </div>
      <div className="Pagination">
        {liveStream?.result?.[0]?.totalCount?.[0]?.count > 0 && (
          <>
            <p>
              Showing {(page - 1) * 10 + 1} to{" "}
              {liveStream?.result?.[0]?.paginationData?.length +
                (page - 1) * 10}{" "}
              of {liveStream?.result?.[0]?.totalCount?.[0]?.count} results
            </p>
            <div className="PaginationRight">
              {liveStream?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                <CommonPagination
                  activePage={page}
                  itemsCountPerPage={10}
                  totalItemsCount={
                    liveStream?.result?.[0]?.totalCount?.[0]?.count || 0
                  }
                  pageRangeDisplayed={4}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default LiveStreamDetails;
